import styled from "styled-components";

export const SectionWrapper = styled.section`
  position: relative;
  width: 100%;
  height: 60vh;
  background: radial-gradient(circle at top left, #0b0617, #000);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #fff;
`;

export const LeftContent = styled.div`
  text-align: center;
  max-width: 900px;
  z-index: 2;
  padding: 20px;
`;

export const Title = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  line-height: 1.3;
  color: #fff;
  margin-bottom: 20px;
  letter-spacing: 1px;
`;

export const Highlight = styled.span`
  background: linear-gradient(90deg, #9b5cff, #c59fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #d5d1e2;
  margin-bottom: 40px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 14px;
  margin-top: 20px;
`;

export const PrimaryButton = styled.button`
  background: linear-gradient(90deg, #9b5cff, #c59fff);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 14px 28px;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 0 12px rgba(155, 92, 255, 0.3);

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(155, 92, 255, 0.6);
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(155, 92, 255, 0.4);
  box-shadow: none;

  &:hover {
    background: rgba(155, 92, 255, 0.15);
    box-shadow: 0 0 15px rgba(155, 92, 255, 0.3);
  }
`;
